import AppController from "./controller/app-controller";
import CookieConsentConfig from "./utils/cookieconsent-config";

document.addEventListener("DOMContentLoaded", async function () {
    new AppController();
    CookieConsent = await import('vanilla-cookieconsent');
    CookieConsentConfig.language.default = document.querySelector('html').getAttribute('lang').split('-')[0];
    CookieConsent.run(CookieConsentConfig);
});
